<uni-icon
  class="uni-step-separator__icon"
  name="arrow-right"
></uni-icon>
